module.exports = __webpack_public_path__ + "06e21dc2b22236c93dc358ad6b5c6265.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/backgrounds/4.jpg
// module id = 391
// module chunks = 0